import isMobilePhone from "validator/es/lib/isMobilePhone";
import * as z from "zod";

// Individual field validators for inline editing
export const ZoneFieldValidators = {
  name: z.string().min(1, "Le nom est requis"),
  region_uuid: z.string().uuid().min(1, "La région est requise"),
  customer_service_id: z
    .string()
    .transform(val => (val && val.trim() !== "" ? parseInt(val) : null))
    .refine(
      val => val === null || (!isNaN(val) && val > 0),
      "L'ID du service client doit être un nombre positif"
    ),
  aircall_phone_number: z
    .string()
    .min(1, "Le numéro de téléphone est requis")
    .refine((val: string) => {
      const cleaned = val.replaceAll(" ", "").replaceAll(".", "");
      return isMobilePhone(cleaned, ["fr-FR"]);
    }, "Veuillez saisir un numéro de téléphone français valide"),
  aircall_main_number_id: z
    .string()
    .min(1, "L'ID du numéro principal est requis")
    .transform(val => parseInt(val))
    .refine(val => !isNaN(val) && val > 0, "L'ID du numéro principal doit être un nombre positif"),
  aircall_rh_number: z
    .string()
    .min(1, "Le numéro de téléphone RH est requis")
    .refine((val: string) => {
      const cleaned = val.replaceAll(" ", "").replaceAll(".", "");
      return isMobilePhone(cleaned, ["fr-FR"]);
    }, "Veuillez saisir un numéro de téléphone français valide"),
  aircall_main_rh_number_id: z
    .string()
    .min(1, "L'ID du numéro principal RH est requis")
    .transform(val => parseInt(val))
    .refine(
      val => !isNaN(val) && val > 0,
      "L'ID du numéro principal RH doit être un nombre positif"
    ),
} as const;

// Additional field validator for zone creation (includes legal entity)
export const ZoneCreationFieldValidators = {
  ...ZoneFieldValidators,
  legal_entity_uuid: z.string().uuid().min(1, "L'entité légale est requise"),
} as const;

// Full creation schema
export const ZoneCreationSchema = z.object(ZoneCreationFieldValidators);

export type ZoneCreationSchemaType = z.output<typeof ZoneCreationSchema>;

// Helper function to validate individual fields
export const validateZoneField = (field: keyof typeof ZoneFieldValidators, value: string) => {
  try {
    const validator = ZoneFieldValidators[field];
    const result = validator.parse(value);
    return { success: true, data: result, error: null };
  } catch (error) {
    if (error instanceof z.ZodError) {
      return { success: false, data: null, error: error.issues[0].message };
    }
    return { success: false, data: null, error: "Échec de la validation" };
  }
};
